import { eventLogs, lastClickArrayIndex } from "./collectEvents";

export const removeDeadClick = () => {
    if(lastClickArrayIndex) {
        if(eventLogs[lastClickArrayIndex] && eventLogs[lastClickArrayIndex].hasOwnProperty('isDead')) {
            delete eventLogs[lastClickArrayIndex].isDead;
        }
    }
}